import React from 'react';

import { LuxuryHomesList } from '@components';

const LuxuryHomesListPage: React.FC = () => {
  return (
    <div className="luxury-homes-list-page">
      <LuxuryHomesList />
    </div>
  );
};

export default LuxuryHomesListPage; 